"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var YandexRu = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M14.3213251,6.3934715 L13.4706961,6.3934715 C12.2060441,6.3934715 11.300463,7.49968912 11.300463,9.51989637 C11.300463,11.453057 12.2640073,12.4976166 13.6415746,12.4976166 L14.3213251,12.4976166 L14.3213251,6.3934715 Z M9.50811991,9.70341969 C9.50811991,6.80041451 11.1755033,5 13.5279065,5 L16,5 L16,19 L14.3213251,19 L14.3213251,13.8910881 L13.5595228,13.8910881 L10.8599997,19 L8.80000019,19 L11.8793423,13.575544 C10.3512212,12.875544 9.50811991,11.5081865 9.50811991,9.70341969 Z" })));
};
YandexRu.displayName = 'YandexRu';
exports.default = YandexRu;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=YandexRu.js.map